import $ from 'jquery'
import './index.scss'
import { inViewportFromTop } from '~/common/helpers/in_viewport'

const activateTOCLink = (link) => {
  $(link)
    .closest('.generated-table-of-contents')
    .find('.sidebar-nav__link')
    .removeClass('sidebar-nav__link--active')

  $(link).closest('.sidebar-nav__link').addClass('sidebar-nav__link--active')
}

const updateTOCActive = () => {
  $('.generated-table-of-contents .sidebar-nav__link').each((i, el) => {
    const content = $(`#${el.href.split('#').pop()}`)[0]
    if (inViewportFromTop(content)) {
      activateTOCLink(el)
      return false // i.e break once we activate one link
    }
  })
}

// This is set to true on a click so we don't jump between active states when multiple items are visible at once
let ignoreScrollEvent = false
window.addEventListener(
  'scroll',
  () => {
    if (!ignoreScrollEvent) {
      updateTOCActive()
    }
  },
  {
    passive: true,
  }
)

$(document).on(
  'click',
  '.generated-table-of-contents .sidebar-nav__link',
  (e) => {
    ignoreScrollEvent = true
    activateTOCLink(e.target)
    setTimeout(() => (ignoreScrollEvent = false), 300)
  }
)
$(updateTOCActive)
